import React from "react";

const PauseIcon = () => {
  return (
    <svg
      aria-hidden={true}
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 12V2"
        stroke="#666666"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.41699 12V2"
        stroke="#666666"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PauseIcon;
